// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Drawer$Showside from "./Drawer.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as IconCart$Showside from "../icons/IconCart.bs.js";
import * as Launcher$Showside from "./Launcher.bs.js";
import * as Favorites$Showside from "./Favorites.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as NavbarItem$Showside from "./NavbarItem.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as CartAnimation$Showside from "./CartAnimation.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as UseAnchorsType$Showside from "../hook/UseAnchorsType.bs.js";
import * as EditorLayerItem$Showside from "./EditorLayerItem.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as UseContextualL1s$Showside from "../hook/UseContextualL1s.bs.js";
import * as UseRollbarAlerts$Showside from "../hook/UseRollbarAlerts.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseCheckoutAction$Showside from "../hook/UseCheckoutAction.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as NavbarHoverMenu_Lazy$Showside from "./NavbarHoverMenu_Lazy.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
import * as UseCategoryDisplayPriority$Showside from "../hook/UseCategoryDisplayPriority.bs.js";
import * as LauncherWithAnchorHighlight$Showside from "./LauncherWithAnchorHighlight.bs.js";
function Navbar$CheckoutButton(Props) {
  var iconSizeDiffOpt = Props.iconSizeDiff;
  var iconsCustomClassOpt = Props.iconsCustomClass;
  var cartIconPixelAdjustmentsOpt = Props.cartIconPixelAdjustments;
  var theme = Props.theme;
  var icon = Props.icon;
  var classNameOpt = Props.className;
  var iconSizeDiff = iconSizeDiffOpt !== undefined ? iconSizeDiffOpt : 0;
  var iconsCustomClass = iconsCustomClassOpt !== undefined ? iconsCustomClassOpt : "";
  var cartIconPixelAdjustments = cartIconPixelAdjustmentsOpt !== undefined ? cartIconPixelAdjustmentsOpt : "0 0 0 0";
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var match = ConfigurationProvider$Showside.use(undefined);
  var settings = match.config.settings;
  var match$1 = CartContextProvider$Showside.useCart(undefined);
  var match$2 = UseCheckoutAction$Showside.useCheckoutAction(undefined);
  var onClick = match$2.onClick;
  var href = match$2.href;
  if (href === undefined && onClick === undefined) {
    return null;
  }
  var tmp = {
    label: "Checkout",
    children: Belt_Option.getWithDefault(icon, React.createElement(IconCart$Showside.make, {
      size: 22 + iconSizeDiff | 0
    })),
    show: Belt_Option.isSome(settings.checkoutLink),
    openLinkInNewTab: settings.openLinkInNewTab,
    className: Cn.make([iconsCustomClass, CSS$Showside.prefix("ml-auto"), className]),
    pixelAdjustments: cartIconPixelAdjustments,
    dataTestId: "navbar-button-checkout",
    badgeDataTestId: "cart-total-count"
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  if (href !== undefined) {
    tmp.href = href;
  }
  var tmp$1 = StringUtils$Showside.fromInt(99, undefined, match$1.cart.itemCount);
  if (tmp$1 !== undefined) {
    tmp.badge = Caml_option.valFromOption(tmp$1);
  }
  if (theme !== undefined) {
    tmp.theme = Caml_option.valFromOption(theme);
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix("relative w-12 h-12")
  }, React.createElement(CartAnimation$Showside.make, {
    productDirection: /* Bottom */1,
    tooltipDirection: /* Left */2,
    addedLabel: settings.pdpAddToCartConfirmation,
    className: CSS$Showside.prefix("absolute top-0 left-0 w-full h-full")
  }), React.createElement(NavbarItem$Showside.make, tmp));
}
Navbar$CheckoutButton.displayName = "Navbar.CheckoutButton";
var CheckoutButton = {
  make: Navbar$CheckoutButton
};
function Navbar$PrimaryNavbar(Props) {
  var categories = Props.categories;
  var settings = Props.settings;
  var hoveredCategory = Props.hoveredCategory;
  var canLoadHoverMenu = Props.canLoadHoverMenu;
  var drawerState = Props.drawerState;
  var setHoveredCategory = Props.setHoveredCategory;
  var onMouseLeave = Props.onMouseLeave;
  var match = LCPContext$Showside.use(undefined);
  var onMainImageRendered = match.onMainImageRendered;
  var isNavOpen = drawerState === /* Opening */1 || drawerState === /* Open */2 || !settings.smartbarEnabled;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onBackClick = match$1.onBackClick;
  var onCloseNavigation = match$1.onCloseNavigation;
  var onHomeClick = match$1.onHomeClick;
  var match$2 = ViewportContext$Showside.use(undefined);
  var isMobileScreen = match$2.isMobile;
  var isUserHoveringCategory = Belt_Option.isSome(hoveredCategory);
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var route = match$3.route;
  var match$4;
  if (typeof route === "number") {
    match$4 = [false, true];
  } else {
    switch (route.TAG | 0) {
      case /* Home */0:
        var match$5 = route._0;
        match$4 = Belt_Option.isNone(match$5.filters) && match$5.homeType === /* Index */0 ? [true, false] : [false, false];
        break;
      case /* ListPage */1:
      case /* PDP */2:
      case /* QuickView */3:
        match$4 = [false, false];
        break;
    }
  }
  var isNavbarOnly = match$4[1];
  var isHome = match$4[0];
  var isInlineNav = match$1.embedType === /* Inline */1;
  var ref = React.useRef(null);
  var height = ListPageLayoutController$Showside.usePrimaryNavbarHeightSetter(ref);
  UseRollbarAlerts$Showside.useNavbarEmptyAlert(categories);
  var sliderWrapperClass = Cn.make([isNavOpen ? "swiper-small-navigation" : "swiper-small-navigation--smartbar", isMobileScreen ? "swiper-mobile" : "swiper-desktop", CSS$Showside.prefix("w-0 flex-grow")]);
  var iconSizeDiff = isMobileScreen ? 2 : 0;
  var canRenderBackIcon = settings.backButton && !isMobileScreen && isNavOpen;
  var canRenderHomeAndOpenIcon = !isMobileScreen && !isInlineNav && settings.smartbarEnabled;
  var favorites = Favorites$Showside.useFavorites(undefined);
  var canRenderFavorites = favorites.source !== /* SourceLocalStorage */0 && isInlineNav ? false : !isMobileScreen && isNavOpen && favorites.enabled;
  var canRenderCartIcon = !isMobileScreen && (!isInlineNav || settings.cart) && (Belt_Option.isSome(settings.checkoutLink) || settings.cart) && isNavOpen && settings.smartbarEnabled;
  var leftItems = [canRenderBackIcon, canRenderHomeAndOpenIcon];
  var rightItems = [canRenderCartIcon, canRenderHomeAndOpenIcon];
  var backIconPixelAdjustments = isMobileScreen ? "0 0 0 -4px" : "0 0 0 0";
  var cartIconPixelAdjustments = isMobileScreen ? "0 -3px 0 0" : "0 0 0 0";
  var forceLabelStyle = !isMobileScreen && !isInlineNav && settings.smartbarEnabled;
  var forceStyle = forceLabelStyle ? /* Labels */0 : undefined;
  var onItemMouseEnter = React.useCallback(function (category) {
    if (drawerState === /* Closed */0) {
      return Curry._1(setHoveredCategory, function (param) {
        return category;
      });
    }
  }, [setHoveredCategory, drawerState]);
  var onItemRendered = React.useCallback(function (param) {
    if (isNavbarOnly) {
      return Curry._1(onMainImageRendered, undefined);
    }
  }, [onMainImageRendered]);
  var isRenderingContent = categories.length !== 0 || canRenderBackIcon || canRenderHomeAndOpenIcon || canRenderCartIcon || canRenderFavorites;
  var paddingCn = isInlineNav ? isMobileScreen ? isRenderingContent ? "py-2" : "" : isRenderingContent ? "py-4 px-5" : "" : isMobileScreen || !isRenderingContent ? "" : "py-1 px-5";
  var isMkrBioActive = settings.mkrBio !== undefined;
  var calculateLostWidth = function (a, b) {
    var numOfItemsItWillRender = Belt_Array.keep(a, function (a) {
      return a;
    }).length;
    var numOfItemsInOppositeSide = Belt_Array.keep(b, function (b) {
      return b;
    }).length;
    var lostWidthMultiplier = Math.max(0, numOfItemsInOppositeSide - numOfItemsItWillRender | 0);
    return Math.imul(38, lostWidthMultiplier);
  };
  var fullWidth = isMobileScreen && categories.length <= 3 && Belt_Option.getWithDefault(forceStyle, settings.categoryLayout) === /* Labels */0;
  var match$6 = settings.mkrBio;
  var slidesPerView = match$6 !== undefined && fullWidth ? String(categories.length) : undefined;
  var leftLostWidth = calculateLostWidth(leftItems, rightItems);
  var rightLostWidth = calculateLostWidth(rightItems, leftItems);
  var tmp = {
    categories: categories,
    centered: !isMobileScreen || isMkrBioActive,
    padded: !fullWidth,
    className: sliderWrapperClass,
    dataTestId: "navbar-l1",
    sliderDataTestId: "navbar-l1-container",
    sliderInsetMargin: "0 " + CSS$Showside.intToPx(rightLostWidth) + " 0 " + CSS$Showside.intToPx(leftLostWidth) + "",
    onItemMouseEnter: onItemMouseEnter,
    onItemClick: match$1.onLauncherItemClick,
    onItemRendered: onItemRendered,
    ariaLabel: "Primary",
    tabIndex: 0,
    theme: settings.smartbarEnabled ? /* Bottombar */1 : /* Main */0
  };
  if (forceStyle !== undefined) {
    tmp.forceStyle = Caml_option.valFromOption(forceStyle);
  }
  if (slidesPerView !== undefined) {
    tmp.slidesPerView = Caml_option.valFromOption(slidesPerView);
  }
  return React.createElement(EditorLayerItem$Showside.make, {
    kind: "menubar",
    fwdRef: ReactDOMUtils$Showside.Ref.domRef(ref),
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["relative", "left-0", "w-full", "flex", "flex-row", "select-none", "touch-none", "rounded-b-none", "z-10", "all", "hide-on-empty", forceLabelStyle ? "h-16" : "", isMobileScreen ? "items-stretch" : "items-center", isNavOpen ? "bg-main text-secondary" : "bg-drawer-main text-drawer-label", paddingCn])),
      onMouseLeave: onMouseLeave
    }, React.createElement(ConditionalRender$Showside.When.make, {
      condition: canLoadHoverMenu && isUserHoveringCategory,
      children: Belt_Option.mapWithDefault(hoveredCategory, null, function (hoveredCategory) {
        return React.createElement(ErrorBoundary$Showside.make, {
          componentName: "NavbarHoverMenu",
          children: React.createElement(NavbarHoverMenu_Lazy$Showside.make, {
            category: hoveredCategory,
            height: height,
            key: hoveredCategory.id
          })
        });
      })
    }), React.createElement(ConditionalRender$Showside.When.make, {
      condition: canRenderBackIcon || canRenderHomeAndOpenIcon,
      children: React.createElement("div", {
        className: CSS$Showside.prefix("flex space-x-2 pr-4")
      }, React.createElement(ConditionalRender$Showside.When.make, {
        condition: canRenderBackIcon,
        children: React.createElement(NavbarItem$Showside.make, {
          label: "Back",
          children: React.createElement(Unicons$Showside.UilAngleLeftB.make, {
            size: /* Px */{
              _0: 26 + iconSizeDiff | 0
            }
          }),
          onClick: function (param) {
            Curry._1(onBackClick, undefined);
          },
          pixelAdjustments: backIconPixelAdjustments,
          disabled: isHome && (isInlineNav || !settings.smartbarEnabled),
          hideOnDisable: isInlineNav,
          dataTestId: "navbar-button-back"
        })
      }), React.createElement(ConditionalRender$Showside.When.make, {
        condition: canRenderHomeAndOpenIcon,
        children: React.createElement(NavbarItem$Showside.make, {
          label: "Home",
          children: React.createElement(Unicons$Showside.UilEstate.make, {
            size: /* Px */{
              _0: 21
            },
            className: CSS$Showside.prefix("w-full")
          }),
          onClick: function (param) {
            if (isHome) {
              return;
            } else {
              return Curry._1(onHomeClick, undefined);
            }
          },
          disabled: isHome,
          dataTestId: "navbar-button-home"
        })
      }))
    }), React.createElement(Launcher$Showside.make, tmp), React.createElement(ConditionalRender$Showside.When.make, {
      condition: canRenderFavorites || canRenderCartIcon || canRenderHomeAndOpenIcon,
      children: React.createElement("div", {
        className: CSS$Showside.prefix("ml-auto flex space-x-2 pl-4")
      }, React.createElement(ConditionalRender$Showside.When.make, {
        condition: canRenderFavorites,
        children: React.createElement(Favorites$Showside.OpenButton.make, {})
      }), React.createElement(ConditionalRender$Showside.When.make, {
        condition: canRenderCartIcon,
        children: React.createElement(Navbar$CheckoutButton, {
          iconSizeDiff: iconSizeDiff,
          cartIconPixelAdjustments: cartIconPixelAdjustments
        })
      }), React.createElement(ConditionalRender$Showside.When.make, {
        condition: canRenderHomeAndOpenIcon,
        children: React.createElement(NavbarItem$Showside.make, {
          label: isNavOpen ? "Close" : "Open",
          children: isNavOpen ? React.createElement(Unicons$Showside.UilTimes.make, {
            size: /* Px */{
              _0: 28
            },
            className: CSS$Showside.prefix("transform rotate-90 cursor-pointer")
          }) : React.createElement(Unicons$Showside.UilAngleLeftB.make, {
            size: /* Px */{
              _0: 28
            },
            className: CSS$Showside.prefix("transform rotate-90 cursor-pointer")
          }),
          onClick: function (param) {
            if (isNavOpen) {
              return Curry._1(onCloseNavigation, undefined);
            } else {
              return Curry._1(onHomeClick, undefined);
            }
          },
          dataTestId: "navbar-button-open-close"
        })
      }))
    }))
  });
}
Navbar$PrimaryNavbar.displayName = "Navbar.PrimaryNavbar";
var make = React.memo(Navbar$PrimaryNavbar);
var PrimaryNavbar = {
  make: make
};
function useSecondaryNavbarKind(topLevelCategories, activeCategory) {
  ViewportContext$Showside.use(undefined);
  var match = ListPageLayoutController$Showside.Context.use(undefined);
  var activeCategoryId = Belt_Option.map(activeCategory, function (c) {
    return c.id;
  });
  var pathDepth = Belt_Option.mapWithDefault(activeCategoryId, [], function (id) {
    return Category$Showside.getCategoryPathById(topLevelCategories, id);
  }).length;
  var isForcingPLP = UseCategoryDisplayPriority$Showside.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */1;
  var secondaryCategories = Category$Showside.getSensibleSiblings(true, isForcingPLP, topLevelCategories, activeCategory);
  var secondaryCategories$1 = Belt_Array.keep(secondaryCategories, function (category) {
    return category.visibleInMenuBar;
  });
  var isActiveCategoryLayoutGrid = Belt_Option.mapWithDefault(activeCategory, false, function (activeCategory) {
    var match = activeCategory.listPageActiveLayout;
    if (typeof match === "number" || match.TAG !== /* SubCategoriesGrid */2) {
      return false;
    } else {
      return true;
    }
  });
  var isSubMenuSliderHidden = match.state.subMenuSliderHeight === 0 || Belt_Array.keep(secondaryCategories$1, function (cat) {
    if (cat.visibleInHeaderSlider) {
      return cat.visibleInParent;
    } else {
      return false;
    }
  }).length === 0;
  var isSecondaryNavbarVisible = pathDepth > 0 && !isActiveCategoryLayoutGrid || pathDepth > 1 || isForcingPLP;
  var isSecondaryCatActive = Belt_Array.some(secondaryCategories$1, function (cat) {
    return cat.id === Belt_Option.getWithDefault(activeCategoryId, "");
  });
  var isFixed = isSecondaryNavbarVisible && isSecondaryCatActive || isForcingPLP || isSubMenuSliderHidden;
  if (isFixed) {
    if (secondaryCategories$1.length !== 0 && isSecondaryNavbarVisible) {
      return {
        TAG: /* Fixed */0,
        _0: secondaryCategories$1
      };
    } else {
      return;
    }
  } else if (secondaryCategories$1.length !== 0 && isSecondaryNavbarVisible) {
    return {
      TAG: /* Dynamic */1,
      _0: secondaryCategories$1
    };
  } else {
    return;
  }
}
function Navbar$SecondaryNavbar$Content(Props) {
  var anchorHookResult = Props.anchorHookResult;
  var kind = Props.kind;
  var match = EntrypointContext$Showside.use(undefined);
  var onLauncherItemClick = match.onLauncherItemClick;
  RouterProvider$Showside.useRouter(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match$1.settings;
  var match$2 = ViewportContext$Showside.use(undefined);
  var ref = React.useRef(null);
  var isFixed;
  isFixed = kind.TAG === /* Fixed */0 ? true : false;
  ListPageLayoutController$Showside.useSecondaryNavbarHeightSetter(isFixed, ref);
  var match$3 = Belt_Option.getWithDefault(anchorHookResult, UseAnchorsType$Showside.empty);
  var onAnchorClick = match$3.onClick;
  var onL2ItemClick = function (category) {
    var isGoingToAnchor = Curry._1(onAnchorClick, category);
    if (!isGoingToAnchor) {
      return Curry._1(onLauncherItemClick, category);
    }
  };
  var key = Belt_Array.map(kind._0, function (category) {
    return category.id;
  }).join("");
  if (kind.TAG === /* Fixed */0) {
    return React.createElement(EditorLayerItem$Showside.make, {
      kind: "menubar",
      fwdRef: ReactDOMUtils$Showside.Ref.domRef(ref),
      children: React.createElement(Launcher$Showside.make, {
        isNested: true,
        categories: kind._0,
        className: CSS$Showside.prefix("text-primary pb-2 pt-3"),
        dataTestId: "navbar-l2",
        sliderDataTestId: "navbar-l2-container",
        onItemClick: onLauncherItemClick,
        ariaLabel: "Secondary",
        tabIndex: 0,
        theme: settings.smartbarEnabled ? /* Bottombar */1 : /* Main */0,
        key: key
      })
    });
  }
  var tmp = {
    autoHide: !match$2.isMobile,
    fwdRef: ref,
    children: React.createElement(Launcher$Showside.make, {
      categories: kind._0,
      className: CSS$Showside.prefix("bg-main pb-2 pt-3 text-primary"),
      dataTestId: "navbar-l2",
      sliderDataTestId: "navbar-l2-container",
      onItemClick: onL2ItemClick,
      ariaLabel: "Secondary",
      tabIndex: 0,
      theme: settings.smartbarEnabled ? /* Bottombar */1 : /* Main */0,
      key: key
    })
  };
  if (match$3.highlightRef !== undefined) {
    tmp.highlightRef = Caml_option.valFromOption(match$3.highlightRef);
  }
  return React.createElement(LauncherWithAnchorHighlight$Showside.make, tmp);
}
Navbar$SecondaryNavbar$Content.displayName = "Navbar.SecondaryNavbar.Content";
var make$1 = React.memo(Navbar$SecondaryNavbar$Content);
var Content = {
  make: make$1
};
function Navbar$SecondaryNavbar(Props) {
  var anchorHookResult = Props.anchorHookResult;
  var topLevelCategories = Props.topLevelCategories;
  var activeCategory = Props.activeCategory;
  var keepDynamicOpt = Props.keepDynamic;
  var keepFixedOpt = Props.keepFixed;
  var keepDynamic = keepDynamicOpt !== undefined ? keepDynamicOpt : true;
  var keepFixed = keepFixedOpt !== undefined ? keepFixedOpt : true;
  var kind = useSecondaryNavbarKind(topLevelCategories, activeCategory);
  var kind$1 = kind !== undefined ? kind.TAG === /* Fixed */0 ? keepFixed ? kind : undefined : keepDynamic ? kind : undefined : undefined;
  if (kind$1 !== undefined) {
    return React.createElement(make$1, {
      anchorHookResult: anchorHookResult,
      kind: kind$1
    });
  } else {
    return null;
  }
}
Navbar$SecondaryNavbar.displayName = "Navbar.SecondaryNavbar";
var make$2 = React.memo(Navbar$SecondaryNavbar);
var SecondaryNavbar = {
  useSecondaryNavbarKind: useSecondaryNavbarKind,
  Content: Content,
  make: make$2
};
function Navbar$NavbarContent(Props) {
  var drawerState = Props.drawerState;
  var activeCategory = Props.activeCategory;
  var topLevelCategories = Props.topLevelCategories;
  var settings = Props.settings;
  var onHoverMenuVisibilityChanged = Props.onHoverMenuVisibilityChanged;
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  var match$2 = Drawer$Showside.Context.use(undefined);
  var setNeedsShadow = match$2.setNeedsShadow;
  LCPContext$Showside.use(undefined);
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var match$4;
  var tmp = match$3.route;
  if (typeof tmp === "number") {
    match$4 = [false, true];
  } else {
    switch (tmp.TAG | 0) {
      case /* Home */0:
        match$4 = [true, false];
        break;
      case /* ListPage */1:
      case /* PDP */2:
      case /* QuickView */3:
        match$4 = [false, false];
        break;
    }
  }
  var match$5 = ListPageLayoutController$Showside.Context.use(undefined);
  var match$6 = match$5.state;
  var showPrimaryNavbar = match$6.showPrimaryNavbar;
  var isInlineNav = match$1.embedType === /* Inline */1;
  var offsetForStickyElements = StickyHeaderOffsetProvider$Showside.useEffective(undefined);
  var offsetForStickyElements$1 = isInlineNav ? offsetForStickyElements : 0;
  var activeCategoryId = Belt_Option.map(activeCategory, function (c) {
    return c.id;
  });
  var match$7 = React.useState(function () {});
  var setHoveredCategory = match$7[1];
  var hoveredCategory = match$7[0];
  var isUserHoveringCategory = hoveredCategory !== undefined;
  var isIndexOrLinkCategory = Belt_Option.mapWithDefault(hoveredCategory, false, function (category) {
    if (Category$Showside.isIndexNode(category)) {
      return true;
    } else {
      return Category$Showside.isLinkCategory(category);
    }
  });
  var canLoadHoverMenu = activeCategoryId === undefined && !isInlineNav && !match.isMobile && !isIndexOrLinkCategory && match$4[1] && settings.smartbarEnabled;
  React.useEffect(function () {
    var needsShadow = hoveredCategory === undefined || !canLoadHoverMenu;
    Curry._1(setNeedsShadow, needsShadow);
  }, [hoveredCategory]);
  React.useEffect(function () {
    Belt_Option.forEach(onHoverMenuVisibilityChanged, function (onHoverMenuVisibilityChanged) {
      Curry._1(onHoverMenuVisibilityChanged, canLoadHoverMenu && isUserHoveringCategory);
    });
  }, [onHoverMenuVisibilityChanged, isUserHoveringCategory, canLoadHoverMenu]);
  var handleSubmenuLeave = React.useCallback(function ($$event) {
    Curry._1(setHoveredCategory, function (param) {});
  }, [setHoveredCategory]);
  var wrapperClassName = isInlineNav ? "sticky" : "sticky left-0 w-full";
  var wrapperStyle = {
    top: showPrimaryNavbar ? CSS$Showside.intToPx(offsetForStickyElements$1) : CSS$Showside.intToPx(Math.imul(-1, match$6.primaryNavbarHeight) + (0 > offsetForStickyElements$1 ? 0 : offsetForStickyElements$1) | 0),
    transitionProperty: "top"
  };
  var primaryCategories = React.useMemo(function () {
    return Belt_Array.keep(topLevelCategories, function (category) {
      return category.visibleInMenuBar;
    });
  }, [topLevelCategories]);
  var tmp$1 = {
    categories: primaryCategories,
    settings: settings,
    canLoadHoverMenu: canLoadHoverMenu,
    drawerState: drawerState,
    setHoveredCategory: setHoveredCategory,
    onMouseLeave: handleSubmenuLeave
  };
  if (hoveredCategory !== undefined) {
    tmp$1.hoveredCategory = Caml_option.valFromOption(hoveredCategory);
  }
  var primaryNavContent = React.createElement(make, tmp$1);
  return React.createElement(DataAttribute$Showside.make, {
    dataActive: showPrimaryNavbar,
    dataTestId: "top-navbar",
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["smartnav-navbar", wrapperClassName, drawerState === /* Opening */1 || drawerState === /* Open */2 || !settings.smartbarEnabled ? "bg-main" : "bg-drawer-main", "transition-top duration-300", "flex flex-col z-30"])),
      style: wrapperStyle
    }, primaryNavContent)
  });
}
Navbar$NavbarContent.displayName = "Navbar.NavbarContent";
var NavbarContent = {
  make: Navbar$NavbarContent
};
function Navbar(Props) {
  var drawerState = Props.drawerState;
  var embedType = Props.embedType;
  var onHoverMenuVisibilityChanged = Props.onHoverMenuVisibilityChanged;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var topLevelCategories = UseContextualL1s$Showside.useContextualL1s(embedType, drawerState, window.location.pathname);
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, topLevelCategories);
  ViewportContext$Showside.use(undefined);
  var tmp = {
    drawerState: drawerState,
    activeCategory: activeCategory,
    topLevelCategories: topLevelCategories,
    settings: match.settings
  };
  if (onHoverMenuVisibilityChanged !== undefined) {
    tmp.onHoverMenuVisibilityChanged = Caml_option.valFromOption(onHoverMenuVisibilityChanged);
  }
  return React.createElement(Navbar$NavbarContent, tmp);
}
Navbar.displayName = "Navbar";
var make$3 = React.memo(Navbar);
var $$default = make$3;
export { CheckoutButton, PrimaryNavbar, SecondaryNavbar, NavbarContent, make$3 as make, $$default, $$default as default };
/* make Not a pure module */